import React from "react";
import Header from "../components/header/Header";

const ChangePassword = () => {
  return (
    <div>
        <Header />
        <h1>Change Password</h1>
    </div>
  )
};

export default ChangePassword;
